module.exports = __webpack_public_path__ + "img/half-half.a2cbd66.png";